import universal from 'react-universal-component';

export default universal(() => import('./RequestUsername'));


// WEBPACK FOOTER //
// ./src/app/views/UsernameRequest/index.js